import React, {type ReactNode} from 'react'
import styles from './ControlButton.module.scss'
import clsx from 'clsx'
import {type ImageURL, type LobbyImage} from '@colonist/types'
import {t, Tooltip} from '@colonist/ui'

type ImageAlt = `strings:imgAlts.${keyof typeof LobbyImage}`

interface ControlButtonProps {
    icon: ImageURL
    alt: ImageAlt
    disabled?: boolean
    onClick?: () => void
    className?: string | undefined
    tooltipContent?: ReactNode | string
    disableTooltip?: boolean | undefined
}

export const ControlButton = ({icon, alt, onClick, className, tooltipContent, disabled, disableTooltip}: ControlButtonProps) => (
    <Tooltip content={tooltipContent} delay={0} menuClassName={styles.tooltipMenu} position="bottom" disabled={disableTooltip}>
        <img
            className={clsx(styles.controlButtonIcon, className, {[styles.disabled]: disabled})}
            onClick={onClick}
            src={icon}
            alt={t(alt)}
        />
    </Tooltip>
)
